document.addEventListener('DOMContentLoaded', function() {
    // Tab switching functionality
    const tabs = document.querySelectorAll('.bag-size-guide__tab');
    const dropdownOptions = document.querySelectorAll('.bag-size-guide__dropdown-option');
    const contentPanels = document.querySelectorAll('.bag-size-guide__collection-content');
    const collectionCTA = document.querySelector('.bag-size-guide__cta-collection');

    // Modal functionality for mobile view
    const modal = document.getElementById('bag-size-guide-modal');
    const modalClose = modal?.querySelector('.bag-size-guide-modal__close');
    const modalOverlay = modal?.querySelector('.bag-size-guide-modal__overlay');
    const modalSlider = modal?.querySelector('.bag-size-guide-modal__slider');
    const modalThumbnails = modal?.querySelector('.bag-size-guide-modal__thumbnails');
    const modalPagination = modal?.querySelector('.bag-size-guide-modal__pagination');

    // Mobile dropdown functionality
    const dropdownSelected = document.querySelector('.bag-size-guide__dropdown-selected');
    const dropdownOptions_container = document.querySelector('.bag-size-guide__dropdown-options');
    const dropdownText = document.querySelector('.bag-size-guide__dropdown-text');

    // Add keyboard accessibility for modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.style.display === 'block') {
        closeModal();
      }
    });

    // Toggle dropdown on click
    if (dropdownSelected) {
      dropdownSelected.addEventListener('click', function() {
        const isOpen = dropdownOptions_container.style.display !== 'none';
        dropdownOptions_container.style.display = isOpen ? 'none' : 'block';
      });
    }

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.bag-size-guide__dropdown') && dropdownOptions_container) {
        dropdownOptions_container.style.display = 'none';
      }
    });

    // Handle dropdown option selection
    dropdownOptions.forEach(option => {
      option.addEventListener('click', function() {
        if (dropdownText) {
          dropdownText.textContent = this.textContent.trim();
        }

        if (dropdownOptions_container) {
          dropdownOptions_container.style.display = 'none';
        }

        dropdownOptions.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');

        const collectionHandle = this.getAttribute('data-collection-handle');
        const correspondingTab = Array.from(tabs).find(tab =>
          tab.getAttribute('data-collection-handle') === collectionHandle
        );

        if (correspondingTab) {
          correspondingTab.click();
        }
      });
    });

    // Function to toggle between all-angles view (slider) and filtered view
    function toggleAngleView(panel, angle) {
      const allAnglesView = panel.querySelector('.bag-size-guide__all-angles-view');
      const filteredView = panel.querySelector('.bag-size-guide__filtered-view');

      if (angle === 'all') {
        allAnglesView.style.display = '';
        filteredView.style.display = 'none';
        initSlider(panel);
      } else {
        allAnglesView.style.display = 'none';
        filteredView.style.display = '';
        filterModelsByAngle(panel, angle);
      }
    }

    // Function to filter models by angle in the filtered view
    function filterModelsByAngle(panel, angle) {
      const filteredView = panel.querySelector('.bag-size-guide__filtered-view');
      const models = filteredView.querySelectorAll('.bag-size-guide__model');
      let hasVisibleModels = false;

      models.forEach(model => {
        if (model.getAttribute('data-angle') === angle) {
          model.style.display = '';
          hasVisibleModels = true;
        } else {
          model.style.display = 'none';
        }
      });

      const emptyMessage = filteredView.querySelector('.bag-size-guide__empty');
      if (emptyMessage) {
        emptyMessage.style.display = hasVisibleModels ? 'none' : '';
      }

      return hasVisibleModels;
    }

    // Initialize angle filters for a panel
    function initAngleFilters(panel) {
      const angleFilters = panel.querySelectorAll('.bag-size-guide__angle-filter');

      angleFilters.forEach(filter => {
        filter.addEventListener('click', function() {
          angleFilters.forEach(f => f.classList.remove('active'));
          this.classList.add('active');
          const angle = this.getAttribute('data-angle');
          toggleAngleView(panel, angle);
        });
      });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        contentPanels.forEach(panel => panel.classList.remove('active'));

        const collectionHandle = this.getAttribute('data-collection-handle');
        const targetPanel = document.querySelector(`.bag-size-guide__collection-content[data-collection-content="${collectionHandle}"]`);

        if (targetPanel) {
          targetPanel.classList.add('active');

          const angleFilters = targetPanel.querySelectorAll('.bag-size-guide__angle-filter');
          angleFilters.forEach(filter => {
            filter.classList.toggle('active', filter.getAttribute('data-angle') === 'all');
          });

          toggleAngleView(targetPanel, 'all');

          if (collectionCTA) {
            const collectionUrl = '/collections/' + collectionHandle;
            collectionCTA.setAttribute('href', collectionUrl);
          }
        }
      });
    });

    // Initialize for the first active panel
    const activePanel = document.querySelector('.bag-size-guide__collection-content.active');
    if (activePanel) {
      initAngleFilters(activePanel);
      toggleAngleView(activePanel, 'all');

      if (collectionCTA) {
        const initialCollectionHandle = activePanel.getAttribute('data-collection-content');
        if (initialCollectionHandle) {
          const collectionUrl = '/collections/' + initialCollectionHandle;
          collectionCTA.setAttribute('href', collectionUrl);
        }
      }
    }

    // Initialize angle filters for all panels
    contentPanels.forEach(panel => {
      initAngleFilters(panel);
    });

    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('bag-link')) {
        event.preventDefault();

        const targetCollection = event.target.getAttribute('data-target-collection');
        if (!targetCollection) return;

        const targetTab = Array.from(tabs).find(tab =>
          tab.getAttribute('data-collection-handle') === targetCollection
        );

        if (targetTab) {
          targetTab.click();
        }
      }
    });

    // Slider functionality for the All Angles view
    function initSlider(panel) {
      const allAnglesView = panel.querySelector('.bag-size-guide__all-angles-view');
      if (!allAnglesView) return;

      const slider = allAnglesView.querySelector('.bag-size-guide__slider');
      const slides = slider.querySelectorAll('.bag-size-guide__slide');
      const prevBtn = slider.querySelector('.bag-size-guide__slider-prev');
      const nextBtn = slider.querySelector('.bag-size-guide__slider-next');
      const dots = slider.querySelectorAll('.bag-size-guide__slider-dot');

      if (slides.length <= 1 || !prevBtn || !nextBtn) return;

      // Clone and replace to strip any previously attached listeners
      const newPrevBtn = prevBtn.cloneNode(true);
      const newNextBtn = nextBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
      nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);

      let currentSlideIndex = 0;

      // Update slide display and active dot
      function updateSlides() {
        slides.forEach((slide, index) => {
          slide.classList.remove('active');
          if (index === currentSlideIndex) {
            slide.classList.add('active');
          }
        });

        dots.forEach((dot, index) => {
          dot.classList.remove('active');
          if (index === currentSlideIndex) {
            dot.classList.add('active');
          }
        });

        initModelCarousel(slides[currentSlideIndex]);
      }

      newPrevBtn.addEventListener('click', function() {
        currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
        updateSlides();
      });

      newNextBtn.addEventListener('click', function() {
        currentSlideIndex = (currentSlideIndex + 1) % slides.length;
        updateSlides();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          currentSlideIndex = index;
          updateSlides();
        });
      });

      let touchStartX = 0;
      let touchEndX = 0;

      // Clone and replace to strip any previously attached listeners
      const newSlider = slider.cloneNode(false);
      Array.from(slider.children).forEach(child => {
        newSlider.appendChild(child);
      });
      slider.parentNode.replaceChild(newSlider, slider);

      newSlider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, false);

      newSlider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, false);

      function handleSwipe() {
        if (touchEndX < touchStartX - 50) {
          newNextBtn.click();
        } else if (touchEndX > touchStartX + 50) {
          newPrevBtn.click();
        }
      }

      updateSlides();

      slides.forEach(slide => {
        initModelCarousel(slide);
      });
    }

    function initModelCarousel(slide) {
      if (!slide) return;

      const carousel = slide.querySelector('.bag-size-guide__models-carousel');
      const models = slide.querySelectorAll('.bag-size-guide__model');
      const prevBtn = slide.querySelector('.bag-size-guide__carousel-prev');
      const nextBtn = slide.querySelector('.bag-size-guide__carousel-next');

      if (!carousel || models.length <= 1 || !prevBtn || !nextBtn) return;

      // Clone and replace to strip any previously attached listeners
      const newPrevBtn = prevBtn.cloneNode(true);
      const newNextBtn = nextBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
      nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);

      let currentModelIndex = 0;

      models.forEach((model, index) => {
        if (model.classList.contains('active')) {
          currentModelIndex = index;
        }
      });

      function updateModels() {
        models.forEach((model, index) => {
          model.classList.remove('active');
        });

        models[currentModelIndex].classList.add('active');

        const modelWidth = models[0].offsetWidth;
        const gap = window.getComputedStyle(carousel).getPropertyValue('gap');
        const gapSize = gap ? parseInt(gap) : 0;

        if (window.innerWidth < 768) {
          const offset = -currentModelIndex * (modelWidth + gapSize);
          carousel.style.transform = `translateX(${offset}px)`;
        } else {
          const offset = -currentModelIndex * (modelWidth + gapSize) + (carousel.offsetWidth / 2 - modelWidth / 2);
          carousel.style.transform = `translateX(${offset}px)`;
        }
      }

      newPrevBtn.addEventListener('click', function() {
        currentModelIndex = (currentModelIndex - 1 + models.length) % models.length;
        updateModels();
      });

      newNextBtn.addEventListener('click', function() {
        currentModelIndex = (currentModelIndex + 1) % models.length;
        updateModels();
      });

      let touchStartX = 0;
      let touchEndX = 0;

      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, false);

      carousel.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleModelSwipe();
      }, false);

      function handleModelSwipe() {
        if (touchEndX < touchStartX - 50) {
          newNextBtn.click();
        } else if (touchEndX > touchStartX + 50) {
          newPrevBtn.click();
        }
      }

      updateModels();
    }

    // Handle "View More Angles" button clicks
    const viewMoreButtons = document.querySelectorAll('.bag-size-guide__view-more-btn, .bag-size-guide-mobile-cards__view-more-btn');
    viewMoreButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const modelName = this.getAttribute('data-model-name');
        const collectionHandle = this.getAttribute('data-collection');
        const sizeTitle = this.getAttribute('data-size-title');
        const sizeDescription = this.getAttribute('data-size-description');
        const currentAngle = this.getAttribute('data-image-angle');
        openModal(modelName, collectionHandle, sizeTitle, sizeDescription, currentAngle);
      });
    });

    function openModal(modelName, collectionHandle, sizeTitle, sizeDescription, currentAngle) {
      if (!modal) return;

      const titleElement = document.getElementById('size__title');
      const descriptionElement = document.getElementById('size__description');
      const imageAngleElement = document.getElementById('size-image-angle');

      if (sizeTitle && titleElement) {
        titleElement.textContent = sizeTitle;
      }

      if (sizeDescription && descriptionElement) {
        descriptionElement.textContent = sizeDescription;
      }

      if (currentAngle && imageAngleElement) {
        imageAngleElement.textContent = `${currentAngle} view`;
      }

      let modelImages = [];

      // Gather this model's images across angles for the current collection only.
      // Both active and non-active panels are searched. Attributes are compared
      // directly rather than interpolated into a selector, so model names containing
      // quotes (e.g. Isabella - 5'8") don't produce an invalid querySelector.
      const collectionModels = Array.from(document.querySelectorAll('.bag-size-guide__model'))
        .filter(model => model.getAttribute('data-collection-handle') === collectionHandle);

      // Prefer an exact model-name match; fall back to a partial (contains) match
      let matchedModels = collectionModels.filter(model => model.getAttribute('data-model-name') === modelName);
      if (matchedModels.length === 0) {
        matchedModels = collectionModels.filter(model => {
          const modelDataName = model.getAttribute('data-model-name');
          return modelDataName && modelDataName.includes(modelName);
        });
      }

      matchedModels.forEach(model => {
        const image = model.querySelector('img');
        const angle = model.getAttribute('data-angle');

        if (image && angle) {
          modelImages.push({
            src: image.src,
            angle: angle,
            alt: image.alt || modelName
          });
        }
      });

      const uniqueAngles = new Set();
      const uniqueModelImages = modelImages.filter(img => {
        if (uniqueAngles.has(img.angle.toLowerCase())) {
          return false;
        }
        uniqueAngles.add(img.angle.toLowerCase());
        return true;
      });

      modelImages.length = 0;
      uniqueModelImages.forEach(img => modelImages.push(img));

      if (modalSlider && modelImages.length > 0) {
        modalSlider.innerHTML = '';
        modalThumbnails.innerHTML = '';
        if (modalPagination) modalPagination.innerHTML = '';

        let currentAngleIndex = 0;
        if (currentAngle) {
          let foundIndex = modelImages.findIndex(img => img.angle.toLowerCase() === currentAngle.toLowerCase());

          if (foundIndex === -1) {
            foundIndex = modelImages.findIndex(img =>
              img.angle.toLowerCase().includes(currentAngle.toLowerCase()) ||
              currentAngle.toLowerCase().includes(img.angle.toLowerCase())
            );
          }

          if (foundIndex !== -1) {
            currentAngleIndex = foundIndex;
          }
        }

        // Create main image with the current angle
        const mainImage = document.createElement('img');
        mainImage.src = modelImages[currentAngleIndex].src;
        mainImage.alt = modelImages[currentAngleIndex].alt;
        mainImage.className = 'bag-size-guide-modal__main-image';
        modalSlider.appendChild(mainImage);

        // Create thumbnails
        modelImages.forEach((img, index) => {
          const thumb = document.createElement('img');
          thumb.src = img.src;
          thumb.alt = `${img.alt} - ${img.angle}`;
          thumb.className = `bag-size-guide-modal__thumbnail${index === currentAngleIndex ? ' active' : ''}`;
          thumb.setAttribute('data-index', index);
          thumb.setAttribute('data-angle', img.angle);
          modalThumbnails.appendChild(thumb);

          thumb.addEventListener('click', function() {
            mainImage.src = img.src;
            mainImage.alt = img.alt;

            modalThumbnails.querySelectorAll('.bag-size-guide-modal__thumbnail').forEach(t => {
              t.classList.remove('active');
            });
            this.classList.add('active');

            if (modalPagination && !modalPagination.classList.contains('hidden')) {
              modalPagination.querySelectorAll('.bag-size-guide-modal__pagination-dot').forEach(dot => {
                dot.classList.remove('active');
              });
              const activeDot = modalPagination.querySelector(`.bag-size-guide-modal__pagination-dot[data-index="${index}"]`);
              if (activeDot) activeDot.classList.add('active');
            }

            const imageAngleElement = document.getElementById('size-image-angle');
            if (imageAngleElement && img.angle) {
              imageAngleElement.textContent = `${img.angle} view`;
            }
          });

          if (modalPagination) {
            const dot = document.createElement('div');
            dot.className = `bag-size-guide-modal__pagination-dot${index === currentAngleIndex ? ' active' : ''}`;
            dot.setAttribute('data-index', index);
            modalPagination.appendChild(dot);

            dot.addEventListener('click', function() {
              const dotIndex = parseInt(this.getAttribute('data-index'));
              const thumbnails = modalThumbnails.querySelectorAll('.bag-size-guide-modal__thumbnail');
              if (thumbnails[dotIndex]) {
                thumbnails[dotIndex].click();
              }
            });
          }
        });

        // Hide pagination when thumbnails already fit the container.
        // Deferred so images have laid out and offsetWidth is accurate.
        if (modalThumbnails && modalPagination) {
          // Wait for images to load to get accurate measurements
          setTimeout(() => {
            const thumbnailsWidth = Array.from(modalThumbnails.children)
              .reduce((total, thumb) => total + thumb.offsetWidth + parseInt(getComputedStyle(thumb).marginLeft) + parseInt(getComputedStyle(thumb).marginRight), 0);
            const containerWidth = modalThumbnails.parentElement.offsetWidth;

            if (thumbnailsWidth <= containerWidth) {
              modalPagination.classList.add('hidden');
              modalPagination.style.display = 'none';
            } else {
              modalPagination.classList.remove('hidden');
              modalPagination.style.display = '';
            }
          }, 100);
        }

        // Add touch scroll functionality to thumbnails
        if (modalThumbnails) {
          let isDown = false;
          let startX;
          let scrollLeft;

          modalThumbnails.addEventListener('mousedown', (e) => {
            isDown = true;
            modalThumbnails.classList.add('active');
            startX = e.pageX - modalThumbnails.offsetLeft;
            scrollLeft = modalThumbnails.scrollLeft;
          });

          modalThumbnails.addEventListener('mouseleave', () => {
            isDown = false;
            modalThumbnails.classList.remove('active');
          });

          modalThumbnails.addEventListener('mouseup', () => {
            isDown = false;
            modalThumbnails.classList.remove('active');
          });

          modalThumbnails.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - modalThumbnails.offsetLeft;
            const walk = (x - startX) * 2;
            modalThumbnails.scrollLeft = scrollLeft - walk;
          });

          modalThumbnails.addEventListener('touchstart', (e) => {
            isDown = true;
            startX = e.touches[0].pageX - modalThumbnails.offsetLeft;
            scrollLeft = modalThumbnails.scrollLeft;
          }, { passive: true });

          modalThumbnails.addEventListener('touchend', () => {
            isDown = false;
          }, { passive: true });

          modalThumbnails.addEventListener('touchmove', (e) => {
            if (!isDown) return;
            const x = e.touches[0].pageX - modalThumbnails.offsetLeft;
            const walk = (x - startX) * 2;
            modalThumbnails.scrollLeft = scrollLeft - walk;
          }, { passive: true });
        }
      }

      modal.style.display = 'block';
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeModal);
    }

    // Function to check if thumbnails exceed container width and update pagination visibility
    function updatePaginationVisibility() {
      if (modal && modal.style.display === 'block' && modalThumbnails && modalPagination) {
        const thumbnailsWidth = Array.from(modalThumbnails.children)
          .reduce((total, thumb) => total + thumb.offsetWidth + parseInt(getComputedStyle(thumb).marginLeft) + parseInt(getComputedStyle(thumb).marginRight), 0);
        const containerWidth = modalThumbnails.parentElement.offsetWidth;

        if (thumbnailsWidth <= containerWidth) {
          modalPagination.classList.add('hidden');
          modalPagination.style.display = 'none';
        } else {
          modalPagination.classList.remove('hidden');
          modalPagination.style.display = '';
        }
      }
    }

    // Update pagination visibility on window resize
    window.addEventListener('resize', () => {
      if (modal && modal.style.display === 'block') {
        updatePaginationVisibility();
      }
    });

    function closeModal() {
      if (modal) {
        modal.style.display = 'none';

        const titleElement = modal.querySelector('.size__title');
        const descriptionElement = modal.querySelector('.size__description');

        if (titleElement) {
          titleElement.textContent = '';
        }

        if (descriptionElement) {
          descriptionElement.textContent = '';
        }
      }
    }
  });